<div class="word-search-word-list" [ngClass]="{'vertical': !horizontal}">
<!--  <ngx-simplebar style="height: 100%; width: 100%;">-->
    <div class="word-search-word-list-inner"
         [style.width]="horizontal ? '' + maxHorizontalWidth + 'px' : '100%'"
         [style.height]="horizontal ? '100%' : '' + maxVerticalHeight + 'px'">
      <ngx-simplebar>
        <div class="word-search-unfound" *ngIf="wordList.length !== foundWords.length">
          <div class="word-list-item" *ngFor="let word of wordList" [ngClass]="{'found': wordIsFound(word)}">
            <div class="word-list-item-inner">{{ word.text }}</div>
          </div>
        </div>
        <div class="word-search-found">
          <div class="word-list-found-item"
               *ngFor="let word of foundWords"
               [@inOutAnimation]>
            <div class="word-list-item-inner">{{ word.text }}</div>
          </div>
        </div>
      </ngx-simplebar>
    </div>
<!--  </ngx-simplebar>-->
</div>

